import styled, { css } from 'styled-components';
import { Card, spaceMixin, token } from '@zillow/constellation';

import { StyledAlignRight } from '../../StyledComponents/StyledComponents';

const getResponsiveMaxWidth = () => {
  return css`
    margin: 0 auto;
    max-width: 608px;
  `;
};

export const StyledCard = styled(Card)<{ cursor?: string; isDisabled?: boolean }>`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;

  height: 100%;
  border-radius: 4px;
  color: ${token('colors.borderLight')};
  cursor: ${({ cursor }) => cursor};

  /* not sure how to use token here */
  &:hover {
    border: ${({ cursor, isDisabled }) => cursor === 'pointer' && !isDisabled && `1px solid #006AFF`};
  }
`;

export const StyledChildContentContainer = styled.div<{ withChevron?: boolean; enableMaxWidth?: boolean }>`
  flex-grow: 1;
  width: 100%;
  height: 100%;

  /**
    * fixes this content pushing the chevron beyond container 
    * ref: https://css-tricks.com/flexbox-truncated-text/#aa-the-solution-is-min-width-0-on-the-flex-child
  */
  min-width: 0;
  margin-right: ${({ withChevron }) => withChevron && spaceMixin('sm')};

  overflow: hidden;

  ${({ enableMaxWidth }) => enableMaxWidth && getResponsiveMaxWidth}
`;

export const StyledEmptyStateContainer = styled.div`
  text-align: center;
  ${getResponsiveMaxWidth}
`;

export const StyledIconContainer = styled(StyledAlignRight)`
  display: flex;
  align-items: center;
`;
